import { Button, type ButtonProps, Loader } from "@octopus-energy/coral/atoms"
import { useActionsContext } from "../../../contexts/actions-context"

export function ActionsAccept({ children, disabled, loading: isLoading, ...props }: ButtonProps) {
    const { loading, step } = useActionsContext()

    return (
        <Button
            loading={loading || isLoading}
            loadingLabel={<Loader size={20} />}
            disabled={loading || disabled}
            attributes={{ "data-testid": step ? "continueButton" : "acceptButton" }}
            {...props}
        >
            {children ?? (step ? "Je continue" : "Valider")}
        </Button>
    )
}
